import {combineReducers} from 'redux';
import modal from './modal';
import alert from './alert';
import loader from './loader';
import stepView from './stepView';

const uiReducer = combineReducers({
    modal,
    alert,
    loader,
    stepView
});

export default uiReducer;